<template>
  <div class="table-box">
    <QueryForm @QuerySearch="QuerySearch" :queryForm="queryForm"></QueryForm>
    <div style="display: none">
      <input
        @change="(e) => uploadInfo(e, '6')"
        id="speechUpload"
        type="file"
      />
    </div>
    <!--        <label for="speechUpload" class="labelImportBtn">-->
    <!--            <span>导入</span>-->
    <!--        </label>-->
    <el-button
      type="primary"
      icon="el-icon-download"
      class="button downOutBtns"
      @click="createExcel"
      >导出
    </el-button>
    <el-button icon="el-icon-delete" type="danger" @click="batchDelete"
      >批量删除
    </el-button>
    <div style="height: 20px"></div>

    <div>
      <el-table
        :data="tableData"
        border
        ref="multipleTable"
        style="width: 100%"
        :header-cell-style="{ background: '#f2f2f2', color: '#000' }"
        @selection-change="handleSelectionChange"
      >
        <el-table-column type="selection" width="50" align="center">
        </el-table-column>
        <el-table-column
          type="index"
          width="70"
          label="序号"
          align="center"
          :show-overflow-tooltip="true"
        >
        </el-table-column>
        <el-table-column
          prop="orderNum"
          label="工单流水号"
          align="center"
          width="220"
          :show-overflow-tooltip="true"
        >
        </el-table-column>
        <el-table-column
          prop="visitResults"
          label="回访结果"
          align="center"
          width="180"
          :show-overflow-tooltip="true"
        >
          <template slot-scope="scope">
            <p v-if="scope.row.visitResults == null">
              <span v-if="scope.row.results == 0">合格</span>
              <span v-else-if="scope.row.results == 1">不合格</span>
              <span v-else-if="scope.row.results == 3">虚假工单</span>
              <span v-else>作废</span>
            </p>
            <p v-else>
              <span v-if="scope.row.visitResults == 0">合格</span>
              <span v-else-if="scope.row.visitResults == 1">不合格</span>
              <span v-else-if="scope.row.visitResults == 3">虚假工单</span>
              <span v-else>作废</span>
            </p>
          </template>
        </el-table-column>
        <el-table-column
          prop="customerName"
          label="客户姓名"
          align="center"
          width="180"
          :show-overflow-tooltip="true"
        >
        </el-table-column>
        <el-table-column
          prop="servePersonName"
          label="服务人员"
          align="center"
          width="150"
          :show-overflow-tooltip="true"
        >
        </el-table-column>
        <el-table-column
          prop="servetypename"
          label="服务类别"
          align="center"
          minWidth="180"
          :show-overflow-tooltip="true"
        >
        </el-table-column>
         <el-table-column
          prop="serveproductNameStr"
          label="服务项目"
          align="center"
          minWidth="180"
          :show-overflow-tooltip="true"
        >
        </el-table-column>
        <el-table-column
          prop="timeStart"
          label="服务开始时间"
          align="center"
          minWidth="220"
          :show-overflow-tooltip="true"
        >
        </el-table-column>
        <el-table-column
          prop="timeEnd"
          label="服务结束时间"
          align="center"
          minWidth="220"
          :show-overflow-tooltip="true"
        >
        </el-table-column>
        <el-table-column
          prop="realPeriod"
          label="工作时长"
          align="center"
          width="180"
          :show-overflow-tooltip="true"
        >
        </el-table-column>
        <el-table-column
          label="操作"
          align="center"
          :show-overflow-tooltip="true"
          width="150"
          fixed="right"
        >
          <template slot-scope="{ row }">
            <el-button type="text" @click="callback(row, '查看')"
              >查看</el-button
            >
            <el-button type="text" @click="delSubmit(row, '删除')"
              >删除</el-button
            >
          </template>
        </el-table-column>
      </el-table>
    </div>
    <div style="height: 20px"></div>
    <div>
      <el-pagination
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :page-sizes="[10, 20, 40, 100]"
        :page-size="query.pageSize"
        layout="total, sizes, prev, pager, next, jumper"
        :total="totalCount"
      >
      </el-pagination>
    </div>
    <VisitDialog
      ref="visitDialog"
      @updateList="getDataList"
      :show-visit.sync="showVisit"
      :showTitle="showTitle"
      :orderInfo="orderInfo"
    ></VisitDialog>

    <returnVisit2
      v-if="dialogVisible1"
      ref="returnVisit"
      @updateList="updateList"
      v-model="dialogVisible1"
      :showTitle="showTitle"
      :deal-flag="true"
      :orderInfo="returnInfo"
    >
    </returnVisit2>
  </div>
</template>

<script>
import request from "@/utils/request.js"
import QueryForm from "@/component/queryform.vue"
import globalTag from "../../components/globalTag"
import VisitDialog from "../component/visitDialog.vue"
import headLine from "../../components/headline"
import returnVisit2 from "../component/returnVisit2.vue"

export default {
  components: {
    globalTag,
    VisitDialog,
    headLine,
    QueryForm,
    returnVisit2,
  },
  data() {
    return {
      dialogVisible1: false,
      showVisit: false,
      showTitle: "",
      queryForm: {
        orderName: "",
        customerType: "",
        serveproductName: "",
        servestationName: "",
        servePersonName: "",
        serviceTypeName:''
      },

      tableData: [],
      multipleSelection: [],
      orderInfo: {
        customerName: "",
      },
      totalCount: 0,
      query: {
        pageNo: 1,
        pageSize: 10,
      },
      isSearchContent: true,
    }
  },
  created() {
    this.getDataList()
  },
  methods: {
    updateList() {
      this.dialogVisible1 = false
      this.getDataList()
    },
    callback(row, title) {
      this.showTitle = title
      row.repeats = row.orderNum.indexOf("-") != -1 ? true : false
      this.returnInfo = row
      this.dialogVisible1 = true
    },
    Reset() {
      this.queryForm = {}
      this.getDataList()
    },
    mobandaochu() {
      this.request2({
        url: "/jjyl/servicePgd/info/Templatedownload",
        method: "POST",
        data: {
          pageNo: this.query.pageNum,
          pageSize: this.query.pageSize,
        },
        responseType: "blob",
      }).then((resp) => {
        if (resp) {
          const blob = new Blob([resp], {
            type: "application/vnd.ms-excel",
          })
          const fileName = "导入模板.xls"
          const linkNode = document.createElement("a")
          linkNode.download = fileName //a标签的download属性规定下载文件的名称
          linkNode.style.display = "none"
          linkNode.href = URL.createObjectURL(blob) //生成一个Blob URL
          document.body.appendChild(linkNode)
          linkNode.click() //模拟在按钮上的一次鼠标单击
          URL.revokeObjectURL(linkNode.href) // 释放URL 对象
          document.body.removeChild(linkNode)
          this.$message.success("导出成功")
        }
      })
    },
    createExcel() {
      this.request2({
        url: "/jjyl/servicePgd/info/export",
        method: "POST",
        excel: true,
        data: {
          customerphone: this.queryForm.customerphone,
          pageNo: this.query.pageNo,
          pageSize: this.query.pageSize,
          orderNum: this.queryForm.orderNum,
          states: "5",
          type: this.queryForm.customerType || "6",
          // customerType: this.queryForm.customerType,
          customerName: this.queryForm.customerName,
          timeStart: this.queryForm.timeStart,
          timeEnd: this.queryForm.timeEnd,
          position: this.queryForm.position,
          servestationName: this.queryForm.servestationName,
          serveproductName: this.queryForm.serveproductName,
          servePersonName: this.queryForm.servePersonName,
          serviceTypeName:this.queryForm.serviceTypeName
        },
        responseType: "blob",
      }).then((res) => {
        if (res) {
          const blob = new Blob([res], {
            type: "application/vnd.ms-excel",
          })
          const fileName = "民政工单.xls"
          const linkNode = document.createElement("a")
          linkNode.download = fileName //a标签的download属性规定下载文件的名称
          linkNode.style.display = "none"
          linkNode.href = URL.createObjectURL(blob) //生成一个Blob URL
          document.body.appendChild(linkNode)
          linkNode.click() //模拟在按钮上的一次鼠标单击
          URL.revokeObjectURL(linkNode.href) // 释放URL 对象
          document.body.removeChild(linkNode)
          this.$message.success("导出表格成功")
        }
      })
    },
    async fileChange(event) {
      const file = event.target.files[0]
      const personType = "1"
      let config = {
        headers: {
          "Content-Type": "multipart/form-data",
        },
      }
      let formData = new FormData()
      formData.append("personType", personType)
      formData.append("file", file)
      let result = await this.$http.post(
        "/jjyl/servicePgd/info/ServicePgdExcel",
        formData,
        config
      )
      // 清空文件
      const fileEle = document.getElementById("speechUpload")
      fileEle.value = ""
      if (result.code === 200) {
        this.$message.success(result.message)
        this.getDataList()
      } else {
        this.$message.warning(result.message)
      }
    },
    getDataList() {
      let params = {
        customerphone: this.queryForm.customerphone,
        pageNo: this.query.pageNo,
        pageSize: this.query.pageSize,
        orderNum: this.queryForm.orderNum,
        pgdStates: ["5", "9"],
        // states: "5",
        type: this.queryForm.customerType || "6",
        customerUserType: this.queryForm.customerUserType,
        customerName: this.queryForm.customerName,
        timeStart: this.queryForm.timeStart,
        timeEnd: this.queryForm.timeEnd,
        position: this.queryForm.position,
        provinceId: this.queryForm.provinceId,
        cityid: this.queryForm.cityid,
        zoneid: this.queryForm.zoneid,
        streetid: this.queryForm.streetid,
        shequid: this.queryForm.shequid,
        servestationName: this.queryForm.servestationName,
        serveproductName: this.queryForm.serveproductName,
        servePersonName: this.queryForm.servePersonName,
        serviceTypeName:this.queryForm.serviceTypeName,
        city: "",
        zone: "",
        street: "",
        shequ: "",
      }
      request({
        url: "/jjyl/servicePgd/info/findServicepgd",
        method: "POST",
        data: params,
      }).then((res) => {
        if (res.code === 200) {
          if (res.content) {
            this.tableData = res.content.list
            this.totalCount = res.content.count
          } else {
            this.tableData = []
            this.totalCount = 0
          }
        }
      })
    },
    statesFormat(row, column) {
      if (row.states === 0) {
        return "待派发"
      } else if (row.states === 1) {
        return "待处理"
      } else if (row.states === 2) {
        return "待回访"
      } else if (row.states === 3) {
        return "服务完成"
      } else if (row.states === 4) {
        return "待作废"
      } else if (row.states === 5) {
        return "已作废"
      } else if (row.states === 100) {
        return "移动终端接单"
      }
    },
    estimateLevelFormat(row, column) {
      if (row.estimateLevel === "1") {
        return "没有服务"
      } else if (row.estimateLevel === "2") {
        return "不满意"
      } else if (row.estimateLevel === "3") {
        return "服务一般"
      } else if (row.estimateLevel === "4") {
        return "基本满意"
      } else if (row.estimateLevel === "5") {
        return "非常满意"
      }
    },
    async detailsVisit(title, row) {
      if (title === "新增") {
        this.showTitle = title
        this.showVisit = true
      } else {
        this.showTitle = title
        await this.getDetails(row.id)
        this.showVisit = true
      }
      // 获取服务类型
      this.$refs.visitDialog && this.$refs.visitDialog.getServiceTypeList()
      // 获取套餐类型
      this.$refs.visitDialog && this.$refs.visitDialog.getEnsureList()
    },
    getDetails(id) {
      request({
        url: "/jjyl/servicePgd/info/findServicepgdById",
        method: "POST",
        data: {
          id: id,
        },
      }).then((res) => {
        if (res.code === 200) {
          if (res.content) {
            this.orderInfo = res.content
          } else {
            this.orderInfo = {}
          }
        }
      })
    },
    QuerySearch() {
      this.getDataList()
    },
    // 点击撤回
    chehui(row) {
      this.$confirm("此操作将撤回该信息, 是否继续?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      }).then(() => {
        request({
          url: "/jjyl/servicePgd/info/withdraw",
          method: "POST",
          data: row,
        }).then((res) => {
          console.log(res)
          if (res.code === 200) {
            this.$message.success("撤回成功")
          } else {
            this.$message.error("撤回失败")
          }
          this.getDataList()
        })
      })
    },
    handleSelectionChange(rows) {
      this.multipleSelection = rows
    },
    batchDelete() {
      var that = this
      var val = this.multipleSelection
      if (val.length > 0) {
        this.$confirm("确认批量删除吗?", "提示", {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning",
        })
          .then(() => {
            var ids = []
            val.forEach(function (item, index) {
              ids.push(item.id)
            })
            console.log(ids, "ids")
            request({
              url: "/jjyl/servicePgd/info/batchDeleteServicepgd",
              method: "POST",
              data: {
                ids: ids,
              },
            })
          })
          .then(() => {
            this.$message({
              type: "success",
              message: "批量删除成功!",
            })
            setTimeout(() => this.getDataList(), 500)
          })
      } else {
        this.$confirm("请选择要删除的项。", "提示")
      }
      this.$refs.multipleTable.clearSelection()
    },
    handleSizeChange(val) {
      this.query.pageSize = val
      this.getDataList()
    },
    handleCurrentChange(val) {
      this.query.pageNo = val
      this.getDataList()
    },
  },
}
</script>

<style lang="less" scoped>
.QuerySearchBtn {
  margin-left: 60px;
}

.table-operation {
  width: 100%;
  display: flex;
  cursor: pointer;
  justify-content: center;

  div {
    flex: 1;
  }
}

.elder_manage_title {
  position: relative;
  width: 100%;
  margin-bottom: 15px;

  &::after {
    position: absolute;
    left: 120px;
    right: 0;
    display: block;
    content: "";
    border-bottom: 1px solid #e4e7ed;
  }

  .title {
    box-sizing: border-box;
    display: inline-block;
    width: 120px;
    height: 40px;
    line-height: 40px;
    text-align: center;
    color: #409eff;
    font-size: 14px;
    border: 1px solid #e4e7ed;
    border-bottom: none;
    border-radius: 4px 4px 0 0;
    box-sizing: border-box;
    background: #ffffff;
  }
}

.searchDomw {
  cursor: pointer;
}
</style>
